import { createEntityAdapter } from "@reduxjs/toolkit";
import { PreviewTaskTemplate } from "./types";

export const previewTasksTemplatesAdapter =
  createEntityAdapter<PreviewTaskTemplate>({
    selectId: (template) => template.id,
  });
